enum ClaimsInsightsRankingRequestTypeEnum {
  Effectiveness = "Effectiveness",
  Efficiency = "Efficiency",
}

export { ClaimsInsightsRankingRequestTypeEnum };
